export interface Theme {
  colors: {
    red: string;
    redOpacity03: string;
    redPressed: string;
    lightRed: string;
    blue: string;
    darkBlue: string;
    blueOpacity10: string;
    bluePressed: string;
    blueHover: string;
    green: string;
    gray900: string;
    gray800: string;
    gray700: string;
    gray600: string;
    gray500: string;
    gray400: string;
    gray200: string;
    gray100: string;
    white: string;
    yellow: string
  };
  breakpoints: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
  states: {
    focus: string;
  };
}

const theme: Theme = {
  colors: {
    red: '#e21216',
    redOpacity03: 'rgba(226, 18, 22, 0.03)',
    lightRed: '#facfcf',
    redPressed: '#af0003',
    blue: '#266dcc',
    darkBlue: '#2264B9',
    blueOpacity10: 'rgba(38, 109, 204, 0.1)',
    bluePressed: '#113e7b',
    blueHover: '#e9f0fa',
    green: '#238618',
    gray900: '#131313',
    gray800: '#222222',
    gray700: '#333333',
    gray600: '#717170',
    gray500: '#828282',
    gray400: '#cfcecc',
    gray200: '#e2e2e0',
    gray100: '#f7f7f7',
    white: '#fff',
    yellow: '#ffd37e'
  },
  breakpoints: {
    sm: '(max-width: 650px)', // this value comes from the PH design system (modal section)
    md: '(max-width: 1024px)',
    lg: '(max-width: 1200px)',
    xl: '(max-width: 2000px)',
  },
  states: {
    focus: 'outline: 2px dashed #e21216',
  },
};

export default theme;
